export default {
    "code": 0,
    "data": {
        "serverTimeStamp": "1668406570676",
        "blockTimeStamp": "1668406566000",
        "blockNum": "45941465"
    },
    "message": "SUCCESS"
}